export default "__VITE_ASSET__nzXEXNDY__"